export default "__VITE_ASSET__js40jR_h__"